export const isRichContent = (content) => {
    return 'nodes' in content;
};
//# sourceMappingURL=is-rich-content.js.map